import React from 'react';
import './ToDoNumber.css';

class ToDoNumber extends React.Component {
  render() {
    if (this.props.items > 0) {
      return (
        <div className="todo-number">
          {this.props.items}
        </div>
      );
    }
    return null;
  }
}

export default ToDoNumber;
